import { ReduxState } from 'state/reducer'

export const selectProfile = (state: ReduxState) => state.profile
